// extracted by mini-css-extract-plugin
export default {"attribute":"ProductAttributes_attribute__jnBo6"};